import { PlatformType } from "@app/constants/platform";
import { useAppSelector } from "@app/redux/store";

export const useIsNetherlands = () => useAppSelector((state) => state.settings.platformId) === PlatformType.NETHERLANDS;
